export const configAPI = {
    api: {
        // prod: "https://yemot.jlab.ymc.li/ym/api/",
        prod: process.env.REACT_APP_ENV_TYPE === 'build' ? "/../ym/api/" : "https://lap.shmuel.net/ym/api/",
        // prod: "http://localhost/ym/api//"
        // prod: "https://www.call2all.co.il/ym/api/"
        // prod: "https://private.call2all.co.il/ym/api/"
        // prod: "/../ym/api/",
    },
    public: {
        prod: '/public/'
    },
    db: {
        local: "http://localhost:4000",
        prod: "http://localhost:4000"
    },
}